/**
 * @generated SignedSource<<42d8d185d20e8e5c5633ca062f6d1f2c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type date_issueFieldDateReadviewFull_DateReadView$data = {
  readonly date: AGG$Date | null | undefined;
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly " $fragmentType": "date_issueFieldDateReadviewFull_DateReadView";
};
export type date_issueFieldDateReadviewFull_DateReadView$key = {
  readonly " $data"?: date_issueFieldDateReadviewFull_DateReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"date_issueFieldDateReadviewFull_DateReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "date_issueFieldDateReadviewFull_DateReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "date"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "54485d98dbf89648bbe321dff0025a79";

export default node;
